const ProfileSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">👤 Thông Tin Cá Nhân</h2>
            <p className="text-slate-700">
                Quản lý hồ sơ cá nhân và cài đặt tài khoản.
            </p>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Thông tin hiển thị:</h3>
                <ul className="text-slate-700 space-y-3">
                    <li className="flex items-start gap-3">
                        <span className="text-xl">📧</span>
                        <div><strong>Email:</strong> Địa chỉ email đăng nhập</div>
                    </li>
                    <li className="flex items-start gap-3">
                        <span className="text-xl">👤</span>
                        <div><strong>Họ tên:</strong> Tên đầy đủ của bạn</div>
                    </li>
                    <li className="flex items-start gap-3">
                        <span className="text-xl">🎓</span>
                        <div><strong>Vai trò:</strong> Sinh viên hoặc Quản trị viên</div>
                    </li>
                    <li className="flex items-start gap-3">
                        <span className="text-xl">📊</span>
                        <div><strong>Thống kê:</strong> Số bài tập đã làm, điểm trung bình</div>
                    </li>
                </ul>
            </div>

            <div className="bg-red-50 p-6 rounded-lg border border-red-200">
                <h3 className="text-lg font-semibold text-red-900 mb-2">🔒 Đổi Mật Khẩu</h3>
                <ol className="text-slate-700 space-y-2 list-decimal list-inside">
                    <li>Nhấn vào biểu tượng hồ sơ trên thanh điều hướng</li>
                    <li>Chọn <strong>"Thông tin cá nhân"</strong></li>
                    <li>Kéo xuống phần <strong>"Đổi mật khẩu"</strong></li>
                    <li>Nhập mật khẩu hiện tại</li>
                    <li>Nhập mật khẩu mới (tối thiểu 6 ký tự)</li>
                    <li>Nhấn <strong>"Đổi mật khẩu"</strong></li>
                </ol>
                <p className="mt-3 text-sm text-red-700">
                    <strong>Lưu ý:</strong> Mật khẩu mới phải khác mật khẩu cũ và có ít nhất 6 ký tự.
                </p>
            </div>
        </div>
    );
};

export default ProfileSection;
